import { SVGInjector } from "@tanem/svg-injector";

const parser = new DOMParser();
const uses = document.querySelectorAll(`svg > use:not([href*="#"])`);

// Adds support for loading external SVG with `<use>` without using fragment.
// Only SVG 2.0 supports that, so we fetch the external SVG and adjust the
// href of `<use>` with A ID.
uses.forEach(use => {
  const href = use.getAttribute("href");
  // Set the extra attribute for SVGInjector.
  use.setAttribute("data-src", href);

  fetch(href)
  .then(res => res.text())
  .then(svg => parser.parseFromString(svg, "image/svg+xml").documentElement)
  .then(svg => {
    const id = svg.getAttribute("id") || "svg";
    svg.setAttribute("id", id);
    use.setAttribute("href", `${ href }#${ id}`);
  });
});

function onElementVisible(element) {
  // Handles the anchors inside.
  const anchors = element.querySelectorAll("a[*|href]:not([href])");
  const offsetParentBoudning = element.getBoundingClientRect();

  anchors.forEach(a => {
    const selector = a.href.baseVal;
    if (!selector) return;
    const modal = document.querySelector(`dialog.flex${ selector }`);
    if (!modal) return;

    const { top, left, width, height } = a.getBoundingClientRect();
    const offsetTop = top - offsetParentBoudning.top;
    const offsetLeft = left - offsetParentBoudning.left;

    modal.style.width = `${ width }px`;
    modal.style.height = `${ height }px`;
    modal.style.setProperty("--tw-translate-x", `${ offsetLeft - offsetParentBoudning.width / 2 }px`);
    modal.style.setProperty("--tw-translate-y", `${ offsetTop - offsetParentBoudning.height / 2 }px`);

    modal.show();

    const circle = a.querySelector("circle");
    if (circle) {
      modal.classList.add("rounded-full");
    }
  });
}

// Because we have different SVG per breakpoints, we use InteractionObserver
// to check when they become visible, and adjust the modals accordingly.
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if(entry.isIntersecting){
      onElementVisible(entry.target);
    } else {
      // el is not visible
    }
  });
}, {
  rootMargin: "0px",
  threshold: 1.0,
});

// Injects the referenced SVG from <use> to the parent SVG.
SVGInjector(uses, {
  afterEach(err, use) {
    if (err) {
      return;
    }

    const svg = use.parentElement;
    const viewBox = use.getAttribute("viewBox");
    if (viewBox) {
      svg.setAttribute("viewBox", viewBox);
    }

    svg.innerHTML = use.innerHTML;

    observer.observe(svg);
  },
});
